import ShowerCommon from "./showerCommon";
import {createParentPositions, ShowerHandTypes, ShowerHeadTypes} from "../../constants";

export default class HandShowerOnly extends ShowerCommon {
  constructor(isChild) {
    super(isChild);
    this.partId = 'hand_shower_only';
    this.partName = 'Hand Shower Only';
    this.translateId = "visualizer.bathroom.shower.hand_shower_only";
    this.canBeDisabled = true;
    this.useMatchingFeatureReplacement = "MountPosition";
    if (isChild) {
      createParentPositions(this);
    }
  }

  handleClick() {
    const showerParent = this.getParent().getParent();
    showerParent.setShowerHeadType(ShowerHeadTypes.shower_arm);
    showerParent.setShowerHandType(ShowerHandTypes.hand_shower_holder);
    super.handleClick();
  }

  hideLayerCondition() {
    const showerParent = this.getParent();
    return showerParent.shower_head_type !== ShowerHeadTypes.shower_arm || showerParent.shower_hand_type !== ShowerHandTypes.hand_shower_holder
  }

  getArrayOfConditions() {
    const showerParent = this.getParent();
    let conditions = super.getArrayOfConditions(); //roomLayout
    //Hand Shower Kit should be displayed with the fixtures that have MountType: 0
    if (showerParent.handShowerHolder && showerParent.handShowerHolder.activeFeature) {
      conditions.push({
        propName: "MountPosition",
        propValue: showerParent.handShowerHolder.activeFeature.metaData["MountPosition"]
          ? showerParent.handShowerHolder.activeFeature.metaData["MountPosition"]
          : ["2"]
      })
    }
    return conditions
  }

}
